/* tslint:disable */
/* eslint-disable */
/**
 * Inhouse API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface GetUpdatedPaymentOperationsOverviewDto
 */
export interface GetUpdatedPaymentOperationsOverviewDto {
    /**
     * 
     * @type {Array<number>}
     * @memberof GetUpdatedPaymentOperationsOverviewDto
     */
    paymentIds: Array<number>;
    /**
     * 
     * @type {Array<number>}
     * @memberof GetUpdatedPaymentOperationsOverviewDto
     */
    pspNotificationIds: Array<number>;
    /**
     * 
     * @type {Array<number>}
     * @memberof GetUpdatedPaymentOperationsOverviewDto
     */
    unknownStatePaymentIds: Array<number>;
}

/**
 * Check if a given object implements the GetUpdatedPaymentOperationsOverviewDto interface.
 */
export function instanceOfGetUpdatedPaymentOperationsOverviewDto(value: object): value is GetUpdatedPaymentOperationsOverviewDto {
    if (!('paymentIds' in value) || value['paymentIds'] === undefined) return false;
    if (!('pspNotificationIds' in value) || value['pspNotificationIds'] === undefined) return false;
    if (!('unknownStatePaymentIds' in value) || value['unknownStatePaymentIds'] === undefined) return false;
    return true;
}

export function GetUpdatedPaymentOperationsOverviewDtoFromJSON(json: any): GetUpdatedPaymentOperationsOverviewDto {
    return GetUpdatedPaymentOperationsOverviewDtoFromJSONTyped(json, false);
}

export function GetUpdatedPaymentOperationsOverviewDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): GetUpdatedPaymentOperationsOverviewDto {
    if (json == null) {
        return json;
    }
    return {
        
        'paymentIds': json['paymentIds'],
        'pspNotificationIds': json['pspNotificationIds'],
        'unknownStatePaymentIds': json['unknownStatePaymentIds'],
    };
}

export function GetUpdatedPaymentOperationsOverviewDtoToJSON(json: any): GetUpdatedPaymentOperationsOverviewDto {
    return GetUpdatedPaymentOperationsOverviewDtoToJSONTyped(json, false);
}

export function GetUpdatedPaymentOperationsOverviewDtoToJSONTyped(value?: GetUpdatedPaymentOperationsOverviewDto | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'paymentIds': value['paymentIds'],
        'pspNotificationIds': value['pspNotificationIds'],
        'unknownStatePaymentIds': value['unknownStatePaymentIds'],
    };
}

